module.exports = __webpack_public_path__ + "static/media/operator_512.2db759d4.png";